<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="RN：" prop="rn1">
                <span>{{model.rn1}}</span>
            </el-form-item>
            <el-form-item label="订单状态：" prop="order_status">
                <span>{{model.order_status}}</span>
            </el-form-item>
            <el-form-item label="交付省份：" prop="location_province">
                <span>{{model.location_province}}</span>
            </el-form-item>
            <el-form-item label="交付城市：" prop="location_city">
                <span>{{model.location_city}}</span>
            </el-form-item>
            <el-form-item label="交付中心名称：" prop="location_title">
                <span>{{model.location_title}}</span>
            </el-form-item>
            <el-form-item label="车型：" prop="car_type">
                <span>{{model.car_type}}</span>
            </el-form-item>
            <el-form-item label="版本：" prop="banben">
                <span>{{model.banben}}</span>
            </el-form-item>
            <el-form-item label="颜色：" prop="yanse">
                <span>{{model.yanse}}</span>
            </el-form-item>
            <el-form-item label="颜色编码：" prop="yanse_code">
                <span>{{model.yanse_code}}</span>
            </el-form-item>
            <el-form-item label="轮毂：" prop="lungu">
                <span>{{model.lungu}}</span>
            </el-form-item>
            <el-form-item label="轮毂编码：" prop="lungu_code">
                <span>{{model.lungu_code}}</span>
            </el-form-item>
            <el-form-item label="内饰：" prop="neishi">
                <span>{{model.neishi}}</span>
            </el-form-item>
            <el-form-item label="内饰编码：" prop="neishi_code">
                <span>{{model.neishi_code}}</span>
            </el-form-item>
            <el-form-item label="订车时间：" prop="order_time">
                <span>{{model.order_time}}</span>
            </el-form-item>
            <el-form-item label="交付时间：" prop="deliver_time">
                <span>{{model.deliver_time}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>            
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deliveryOrderInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                rn: '',
                rn1: '',
                order_status: '',
                location_province: '',
                location_city: '',
                location_title: '',
                car_type: '',
                banben: '',
                yanse: '',
                yanse_code: '',
                lungu: '',
                lungu_code: '',
                neishi: '',
                neishi_code: '',
                order_time: '',
                update_time: '',
                deliver_time: '',
                add_time: '',
                is_loop: '',
                is_in_lib: '',
            },
            getObj:{
                url:'/api/admin/deliveryorder/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>